import React, {useState, useEffect } from 'react';
import {
  Grid,
  Header,
  Segment,
  Dropdown,
} from 'semantic-ui-react';

import ResponsiveContainer from 'components/layout/PageComponents';

import { CsvToHtmlTable } from 'react-csv-to-table';

import { createOptionsArray } from 'utils/utils'

const eventData = [
  {
    text: 'August 2017',
    key: 1,
    url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/bangladesh/flood-events/event2/aug17_relief_costs_table.csv'
  },
  {
    text: 'August 2019',
    key: 2,
    url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/bangladesh/flood-events/2019-august/aug19_relief_costs_table.csv'
  },
  {
    text: 'July 2020',
    key: 3,
    url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/bangladesh/flood-events/2020-july/jul20_relief_costs_table.csv'
  },

]


export default () => {

  const [data, setData] = useState({csv: '', isFetching: false});
  const [event, setEvent] = useState(eventData[0])


  useEffect(() => {
    const fetchCsv = async () => {
      try {
        setData({csv: '', isFetching: true});
        const response = await fetch(event.url);
        setData({csv: await response.text(), isFetching: false});
      } catch (e) {
        setData({csv: '', isFetching: false});
      }
    };
    fetchCsv();
  }, [event])

  return (
    <ResponsiveContainer height={100} currentPage="tables">
      <Segment style={{ padding: '3em 0em' }} vertical>
        <Grid container stackable verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column width={8}>
              <Header as='h2' style={{ fontSize: '2em' }}>
                Relief costs
              </Header>
            </Grid.Column>
            <Grid.Column width={8}>
              <Dropdown
                selection
                options={createOptionsArray(eventData)}
                onChange={(evt, selector) => {
                  console.log(selector.value)
                  const event = eventData.find(event => event.key === selector.value);
                  setEvent(event)
                }}
                value={event.key}/>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>

            <CsvToHtmlTable data={data.csv} csvDelimiter=',' />

          </Grid.Row>
        </Grid>
      </Segment>
    </ResponsiveContainer>
  )
}

